import { createRecipe } from './runtime';

const chipConfig = {"name":"chip","defaultVariants":{"tone":"neutral"},"variantMap":{"static":["true"],"tone":["accent","neutral"]}}

export const chip = /* @__PURE__ */ createRecipe(chipConfig)